import type { JSX } from 'react';
import { PROFILE_HEADING_SUBTITLE, PROFILE_HEADING_TITLE } from '../types/candidate-wizard.types';

interface CandidateProfileHeadingProps {
  name?: string;
  email?: string;
}

export function CandidateProfileHeading({
  name,
  email,
}: CandidateProfileHeadingProps): JSX.Element {
  return (
    <header className="space-y-2">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {name && <span className="text-sm text-muted-foreground">{name}</span>}
        {name && email && <span className="text-sm text-muted-foreground">·</span>}
        {email && <span className="text-sm break-all text-muted-foreground">{email}</span>}
      </div>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{PROFILE_HEADING_TITLE}</h1>
      </div>
      <p className="max-w-3xl text-sm text-muted-foreground sm:text-base">
        {PROFILE_HEADING_SUBTITLE}
      </p>
    </header>
  );
}
